/**
 * Custom web component for handling breadcrumb navigation.
 * Displays dynamic breadcrumbs based on the current page template and last visited collection.
 * @extends HTMLElement
 */
class BreadcrumbsComponent extends HTMLElement {
  /**
   * Creates an instance of BreadcrumbsComponent.
   */
  constructor() {
    super();
  }

  /**
   * Lifecycle callback when element is connected to the DOM.
   * Initializes the breadcrumb navigation.
   */
  connectedCallback() {
    this.updateBreadcrumbs();
  }

  /**
   * Updates the breadcrumb navigation based on the current template and stored collection data.
   * Adds collection link and product title for product pages.
   * @private
   */
  updateBreadcrumbs() {
    const lastCollection = JSON.parse(localStorage.getItem('lastCollection'));
    const breadcrumbsNav = this.querySelector('.page-breadcrumbs .breadcrumbs');

    const productTitle = document.createElement('span');
    productTitle.className = 'breadcrumbs__item';
    productTitle.textContent = window.productData.title;
    if (lastCollection) {
      const collectionLink = document.createElement('a');
      collectionLink.href = lastCollection.url;
      collectionLink.className = 'breadcrumbs__item breadcrumbs__link';
      collectionLink.textContent = lastCollection.title;

      const separator = document.createElement('span');
      separator.className = 'breadcrumbs__separator';
      separator.innerHTML = `<span>&nbsp;</span> / <span>&nbsp;</span>`;

      breadcrumbsNav.appendChild(collectionLink);
      breadcrumbsNav.appendChild(separator);
    }
    breadcrumbsNav.appendChild(productTitle);
  }
}

customElements.define('breadcrumbs-component', BreadcrumbsComponent);